module.exports = __webpack_public_path__ + "img/howItWorksDesktop.07c5c015.png";